// TODO: Deprecated in favor of date_time_formats.js (once things merge)
import moment from 'moment';
import 'moment-timezone';

export const defaultFormat = 'MM/DD/YYYY [at] h:mma';
let timezone;

export function rfcToString(rfc, includeTimezone = true) {
  timezone = timezone || moment.tz.guess();
  const format = includeTimezone ? `${defaultFormat} z` : defaultFormat;
  return moment(rfc).tz(timezone).format(format);
}
